<template>
    <div>
        <div class="text-center mb-2">
            <h1 class="text-theme-primary text-3xl font-bold">
                Carga de productos con archivo
            </h1>
            <p class="mt-2 text-theme-base max-w-2xl mx-auto text-sm">
                Sube, actualiza productos y referencias al sistema de forma
                masiva usando un archivo. Elige la herramienta que mejor se
                adapte a lo que necesitas hacer.
            </p>
        </div>

        <div class="container mx-auto mt-8">
            <div class="flex flex-wrap justify-center gap-4">
                <router-link
                    to="/app/products/massive/update-prices"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-red rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">💰</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Solo precios
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Actualización masiva de precios
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Actualiza los precios de referencias ya existentes
                            identificadas por código de barras.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">🔄</span>
                                <span>
                                    Actualiza precio de venta, precio anterior y
                                    costo de cada referencia
                                </span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">🔄</span>
                                <span>
                                    Si la referencia es predeterminada,
                                    actualiza también el producto padre
                                </span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">⏭</span>
                                <span>
                                    No crea referencias nuevas ni modifica otros
                                    datos
                                </span>
                            </li>
                        </ul>

                        <div
                            class="mt-4 text-center text-sm font-semibold text-white"
                        >
                            Ir a la herramienta →
                        </div>
                    </div>
                </router-link>

                <router-link
                    to="/app/products/massive/load"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-blue rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">🛍</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Solo creación
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Carga masiva de productos
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Crea productos y referencias nuevos. Los que ya
                            existen se omiten sin modificarse.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>
                                    Crea el producto si no existe (identificado
                                    por SKU)
                                </span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>
                                    Crea la referencia si no existe
                                    (identificada por código de barras)
                                </span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>
                                    Agrupa referencias con el mismo SKU bajo un
                                    solo producto
                                </span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">⏭</span>
                                <span>
                                    Omite productos y referencias que ya existen
                                </span>
                            </li>
                        </ul>

                        <div
                            class="mt-4 text-center text-sm font-semibold text-white"
                        >
                            Ir a la herramienta →
                        </div>
                    </div>
                </router-link>

                <router-link
                    to="/app/products/massive/load-and-updates"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-magenta rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">♻️</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Creación + Actualización
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Carga y actualización masiva
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Crea productos nuevos y también actualiza los
                            existentes con la información del archivo.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Crea el producto si no existe</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span>Crea la referencia si no existe</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">🔄</span>
                                <span>Actualiza el producto si ya existe</span>
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">🔄</span>
                                <span
                                    >Actualiza la referencia si ya existe</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">🔄</span>
                                <span
                                    >Si el producto existe pero la referencia
                                    no, actualiza el producto y crea la
                                    referencia</span
                                >
                            </li>
                        </ul>

                        <div
                            class="mt-3 p-2 rounded-lg text-xs flex gap-1.5 bg-white bg-opacity-10"
                        >
                            <span class="flex-shrink-0">⚠️</span>
                            <span>
                                Puede modificar productos ya configurados. Úsala
                                solo si confías plenamente en el archivo.
                            </span>
                        </div>

                        <div
                            class="mt-3 text-center text-sm font-semibold text-white"
                        >
                            Ir a la herramienta →
                        </div>
                    </div>
                </router-link>

                <router-link
                    to="/app/products/massive/load-with-inventories"
                    class="text-decoration-none w-full sm:w-80"
                >
                    <div
                        class="button-card h-full bg-brand-purple rounded-xl p-5 shadow-sm text-white flex flex-col"
                    >
                        <div class="flex items-start gap-3 mb-3">
                            <span class="text-4xl leading-none">🧮</span>
                            <div>
                                <span
                                    class="inline-block text-xs font-semibold bg-white bg-opacity-20 text-white px-2 py-0.5 rounded-full mb-1"
                                >
                                    Creación + Inventario
                                </span>
                                <h5
                                    class="text-white font-semibold leading-tight"
                                >
                                    Carga masiva con inventario
                                </h5>
                            </div>
                        </div>

                        <p class="text-sm mb-3 opacity-90">
                            Ideal para la primera carga. Crea productos,
                            referencias y registra el inventario en el tienda
                            seleccionado.
                        </p>

                        <hr class="mb-3 opacity-20" />

                        <ul
                            class="text-sm space-y-2 flex-1 list-none ps-0 opacity-90"
                        >
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Crea el producto y la referencia si no
                                    existen</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Registra el inventario en el tienda
                                    seleccionado</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Si el producto existe pero la referencia
                                    no, crea la referencia y registra
                                    inventario</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">✅</span>
                                <span
                                    >Si producto y referencia existen pero no
                                    hay inventario, solo lo registra</span
                                >
                            </li>
                            <li class="flex gap-2">
                                <span class="flex-shrink-0">⏭</span>
                                <span
                                    >Si todo ya existe (producto, referencia e
                                    inventario), no hace nada</span
                                >
                            </li>
                        </ul>

                        <div
                            class="mt-4 text-center text-sm font-semibold text-white"
                        >
                            Ir a la herramienta →
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProductsLoad"
};
</script>
